import { FC, useState } from "react";
import { Form, Input, Button } from "antd";
import { changePassword } from "../../util/Setting.util";
import { OpenNotification } from "../../../common/Notification/Notification.component";
import { Message, NotificationType } from "../../../../constants/Constants";
import { ErrorHandler } from "../../../../utilities/utilities";

const CredentialComponent: FC = () => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const submit = (value: any) => {
    setLoading(true);
    changePassword({ password: value.new_password })
      .then(() => {
        setLoading(false);
        form.resetFields();
        OpenNotification(
          NotificationType.SUCCESS,
          "Password Updated",
          "Your password has been changed successfully"
        );
      })
      .catch((error) => {
        setLoading(false);
        ErrorHandler(error).map((e: any) =>
          OpenNotification(
            NotificationType.ERROR,
            "Failed to Update Password",
            e.message
          )
        );
      });
  };

  return (
    <Form layout="vertical" onFinish={submit} form={form}>
      <div className="row">
        <div className="col-md-12">
          <Form.Item
            label="Current Password"
            rules={[
              { required: true, message: "Please enter your current password" },
            ]}
            name="current_password"
          >
            <Input.Password placeholder="Enter current password" />
          </Form.Item>
        </div>
        <div className="col-md-12">
          <Form.Item
            label="New Password"
            rules={[
              { required: true, message: "Please enter a new password" },
              { min: 6, message: "Password must be at least 6 characters" },
            ]}
            name="new_password"
          >
            <Input.Password placeholder="Enter new password" />
          </Form.Item>
        </div>
        <div className="col-md-12">
          <Form.Item
            label="Confirm New Password"
            rules={[
              { required: true, message: "Please confirm your new password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("new_password") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("The two passwords do not match!")
                  );
                },
              }),
            ]}
            name="confirm_password"
          >
            <Input.Password placeholder="Confirm new password" />
          </Form.Item>
        </div>
        <div className="col-md-12">
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              Change Password
            </Button>
          </Form.Item>
        </div>
      </div>
    </Form>
  );
};

export default CredentialComponent;
